export const TasksStyleV1 = () => ({
  tasksListing: {
    height: 'calc(100vh - 120px)',
  },
});
